import { combineReducers } from 'core/redux'

import contactState from './contactState'
import integrations from './integrations'

export default combineReducers({
  integrations,
  contactState,
})
